<template>
  <page
    :title="promo ? 'Promo Group - #' + promo.id : ''"
    backTo="/analytics/promo"
    :loading="promo === null"
    size="is-desktop"
  >
    <div slot="page-header-right">
      <a class="button mr-2" :href="generateData(this.$route.params.id)" target="_blank">Export Coupons</a>
      <a class="button mr-2 is-primary" :href="'/admin/analytics/promo/'+ this.$route.params.id + '/coupons'">Coupons</a>

      <button class="button is-primary" @click="create">
        <b-icon icon="plus"></b-icon>
        <span>
            <slot>Generate new coupons</slot>
          </span>
      </button>
      <button class="button is-primary ml-2" @click="edit(promo)">
        <span>
            <slot>Edit</slot>
          </span>
      </button>
    </div>

    <div class="box" v-if="promo">
      <div class="level">
        <div class="level-left">
          <div class="media" style="align-items: center;">
            <div>
              <div class="subtitle"> {{ promo.name.toUpperCase() }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="promo">
      <table class="table is-fullwidth is-kv">
        <tr>
          <td>Logo</td>
          <td>
            <img :src="promo.logo_image_url" width="80" />
          </td>
        </tr>
        <tr>
          <td>Key</td>
          <td>{{ promo.key }}</td>
        </tr>

        <tr>
          <td>Expire Date</td>
          <td>{{ promo.expired_at }}</td>
        </tr>

        <tr>
          <td>Description</td>
          <td>{{ promo.description }}</td>
        </tr>

        <tr>
          <td>Redemption Message</td>
          <td>{{ promo.redemption_message }}</td>
        </tr>

        <tr>
          <td>Coupons Count</td>
          <td>{{ promo.coupons_count }}
            (<a :href="'/admin/analytics/promo/'+ this.$route.params.id + '/coupons'">Show</a>)
          </td>
        </tr>

        <tr>
          <td>Redeemed Count</td>
          <td>{{ promo.redeemed_count }}</td>
        </tr>

        <tr>
          <td>Unredeemed Count</td>
          <td>{{ promo.unredeemed_count }}</td>
        </tr>
        <tr>
          <td>Background image</td>
          <td>
            <img :src="promo.background_image_url" width="400" />
          </td>
        </tr>
      </table>
    </div>
  </page>
</template>

<script>

import GenerateNewCoupons from "@/modules/admin/pages/promo/components/GenerateNewCoupons";
import EditPromoCoupon from "@/modules/admin/pages/promo/components/EditPromoCoupon";

export default {
  data() {
    return {
      promo: null
    };
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    }
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/promo/group/" + this.$route.params.id)
        .then(response => {
          this.promo = response.data.data;
        })
        .catch(() => {
          alert("Couldn't fetch data from the server.");
        });
    },

    create() {
      this.$buefy.modal.open({
        component: GenerateNewCoupons,
        props: {
          group_id: this.$route.params.id,
          added: () => this.load(),
        },
      });
    },
    edit(promotion) {
      this.$buefy.modal.open({
        component: EditPromoCoupon,
        props: {
          promotion,
          added: () => this.load(),
        },
      });
    },

    generateData(id) {
      return (
        `/admin/api/analytics/promo/${id}/export`
      );
    },
  }
};
</script>
